/**
 * Project domain model for the global "Improvement Work" surface, consumed by
 * the Project Cockpit (future) and the `projectPulse` dashboard widget (via the
 * lightweight `PulseProject` projection below). Data only — presentation
 * concerns (health → colour class, health → label) are owned by the design
 * system / consuming app, never carried on the wire.
 *
 * Seed fixtures (`SEED_PROJECTS`) live in the mock layer, not here.
 */
export const PROJECT_HEALTHS = [
    "green",
    "amber",
    "red",
    "blue",
    "grey",
];
export const PROJECT_STATUSES = [
    "Proposed",
    "Approved",
    "Active",
    "At Risk",
    "Blocked",
    "Verified",
    "Standardized",
    "Completed",
    "Archived",
];
export const PROJECT_TYPES = [
    "Quick Improvement",
    "Kaizen Event",
    "Cross-functional Project",
    "Recovery Project",
    "Standardization Project",
    "Strategic Initiative",
];
export const PROJECT_SOURCES = [
    "DPM Red KPI",
    "VSM Kaizen Burst",
    "Hoshin Objective",
    "SOLVE Countermeasure",
    "Obeya Decision",
    "Supplier Quality Review",
    "PlayerAI Recommendation",
    "Manual",
];
//# sourceMappingURL=project.js.map